import { render, staticRenderFns } from "./DetailBtns.vue?vue&type=template&id=27d15ddb&scoped=true&"
import script from "./DetailBtns.vue?vue&type=script&lang=js&"
export * from "./DetailBtns.vue?vue&type=script&lang=js&"
import style0 from "./DetailBtns.vue?vue&type=style&index=0&id=27d15ddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d15ddb",
  null
  
)

export default component.exports